export const LOCAL_SERVICE_QUOTE_FLOW_TYPE = "local_service_quote";

export const LOCAL_SERVICE_QUOTE_PRESET = {
  template: "recruitment",
  blueprintKind: "booking",
  paymentMethod: "none",
  items: [],
  components: [
    {
      type: "qualification_section",
      title: "Job details",
      description: "Tell us what needs cleaning so we can quote accurately.",
      questions: [
        {
          id: "what_needs_cleaning",
          label: "What needs cleaning?",
          input: "select",
          category: "service_type",
          options: [
            "Carpet cleaning",
            "Rug cleaning",
            "Upholstery / sofa cleaning",
            "Mattress cleaning",
            "Stain or odour treatment",
            "Other",
          ],
        },
        {
          id: "rooms_or_items",
          label: "How many rooms or items need cleaning?",
          input: "select",
          category: "job_size",
          options: [
            "1 room or item",
            "2 rooms or items",
            "3 rooms or items",
            "4 rooms or items",
            "5+ rooms or items",
            "Not sure yet",
          ],
        },
        {
          id: "stains_odours_pets",
          label: "Are there any stains, odours or pet-related issues?",
          input: "select",
          category: "job_condition",
          options: [
            "No",
            "Yes - light staining",
            "Yes - heavy staining",
            "Yes - pet odours or pet accidents",
            "Not sure",
          ],
        },
        {
          id: "postcode_or_area",
          label: "What is the postcode or area for the job?",
          input: "text",
          category: "location",
          placeholder: "MK9 or your area",
        },
      ],
    },
    {
      type: "qualification_section",
      title: "Timing and follow-up",
      description: "Help us follow up with the right timing and contact method.",
      questions: [
        {
          id: "preferred_timing",
          label: "When would you like the cleaning done?",
          input: "select",
          category: "start_timing",
          options: [
            "As soon as possible",
            "This week",
            "In the next 2 weeks",
            "Later this month",
            "Just researching for now",
          ],
        },
        {
          id: "preferred_contact_method",
          label: "How would you prefer to be contacted?",
          input: "select",
          category: "preferred_contact",
          options: ["Phone", "Email", "WhatsApp"],
        },
        {
          id: "photos_later",
          label: "Would you be happy to send photos later if needed?",
          input: "select",
          category: "photos",
          options: ["Yes", "No"],
        },
        {
          id: "extra_details",
          label: "Anything else we should know?",
          input: "textarea",
          category: "enquiry_details",
          optional: true,
          placeholder: "Access notes, parking, stains, pets, or anything else helpful",
        },
      ],
    },
  ],
  templateMeta: {
    flowType: LOCAL_SERVICE_QUOTE_FLOW_TYPE,
    recruitmentMode: "intake",
    label: "Quote Request",
    heroTitle: "Request your carpet cleaning quote",
    heroSubtitle: "Answer a few quick questions so we can price the job properly and get back to you fast.",
    intro: "Answer a few quick questions and we’ll get back to you with the next step.",
    metaDescription: "Short quote request form for local carpet cleaning, rug cleaning, and upholstery enquiries.",
    serviceBadgeLabel: "Guided quote request",
    nextStepEyebrow: "Get a quote",
    nextStepTitle: "Tell us about the job",
    nextStepSubtitle: "Share the cleaning details, your area, and how you'd like us to follow up.",
    jobTitle: "Carpet cleaning",
    location: "",
    recruiterName: "",
    employmentType: "",
    salaryRange: "",
    department: "Carpet, rug, upholstery, and stain-treatment enquiries handled with a quick local follow-up.",
    roleLabel: "Service",
    salaryLabel: "What we help with",
    organisationLabel: "Business",
    locationLabel: "Service area",
    validUntilPrefix: "Link available until",
    timeBadgeTemplate: "Takes ~{minutes}",
    contactRequired: true,
    nameRequired: true,
    minRequiredQuestions: 3,
    leadFormTitle: "Your contact details",
    leadFormSubtitle: "Add the best details for the team to reply with a quote.",
    leadFormSubmitLabel: "Request quote",
    leadFormNameLabel: "Full name",
    leadFormNamePlaceholder: "Your name",
    leadFormEmailLabel: "Email address",
    leadFormEmailPlaceholder: "name@email.com",
    leadFormPhoneLabel: "Phone number",
    leadFormPhonePlaceholder: "Best contact number",
    leadFormDisclaimer: "Your details are only used to respond to this quote request.",
    leadFormReviewNote: "Your answers are reviewed so the team can confirm scope, timing, and next steps.",
    selectPlaceholder: "Select",
    sectionFallbackTitle: "Section",
    questionFallbackLabel: "Question",
    shortAnswerPlaceholder: "Short answer",
    emptyStateCopy: "Questions will appear here once configured.",
    confirmationTitle: "Thanks — we’ve got your quote request.",
    confirmationSubtitle: "We’ll review the details and come back with the best next step.",
    confirmationNextSteps: "If we need anything else, we’ll get in touch using your preferred contact method.",
    confirmationSecondary: "You do not need to do anything else right now.",
  },
};
